import { IBasePagedModel, IBaseSortModel } from '../../../../interfaces/PagedSortedSearch';

import ApiClient from '../../../../services/apiClient';
import { HttpResponseError } from '../../../../interfaces/IHttpResponseError';
import { IUserModel } from '../../../../interfaces/IUser';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export enum SameCaseSortColumns {
    OrganizationName = 1,
    CaseName = 2,
    CaseNumber = 3,
    Jurisdiction = 4,
    SameCase = 5,
}

export enum SameCaseStatusType {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

export enum SameCaseSearchStatusEnum {
    Open = 1,
    Closed = 2,
    Inactive = 3,
}

export const SAMECASESEARCHSTATUSOPENLABEL = 'Open';
export const SAMECASESEARCHSTATUSCLOSEDLABEL = 'Closed';
export const SAMECASESEARCHSTATUSINACTIVELABEL = 'Inactive';

export interface ISameCaseMatchResponseModel {
    guid: string;
    caseNumber: string;
    jurisdiction: string;
    caseName: string;
    caseFileModelId: number;
    matchedCases: IMatchedCasesSearchResponseModel[];
}

export interface IMatchedCasesSearchResponseModel {
    alternativeCaseManager?: IUserModel;
    sameCaseGuid?: string;
    caseGuid: string;
    caseManagerUser?: IUserModel;
    caseName: string;
    caseNumber: string;
    jurisdiction: string;
    organizationGuid: string;
    organizationName: string;
    detailedOrganizationName: string;
    uniqueCaseId: string;
    plaintiffFirm: string;
    nationalPlaintiffFirm: string;
    status: string;
    sameCaseStatusTypeId: SameCaseStatusType;
}

export const ShowAllNewAndChangesSameCasesDisplayLabel = 'Only New / Changes';
export const ShowAllRejectedSameCasesDisplayLabel = 'Include Rejected';
export const ShowOnlyRejectedSameCasesDisplayLabel = 'Only Rejected';
export const ShowAllClosedInfoText =
    'By default, the list only displays New Same Case Groups or changes to existing Same Case Groups. To view all closed cases, check “Show All Closed Same Case Groups”.';
export const ShowAllOpenInfoText =
    'By default, the list only displays New Same Case Groups or changes to existing Same Case Groups. To view all open cases, check “Show All Open Same Case Groups”.';
export const SameCaseApprovedHelperText =
    'This field cannot be edited because it is a part of a same case group.';
export const SameCasePendingHelperText =
    'This field cannot be edited because it is a part of a potential same case group.';
export interface ISameCaseMatchedCasesSearchModel {
    caseFileModelId?: number;
    caseNumber?: string;
    jurisdictions?: string[];
    name?: string;
    states?: string[];
    statuses?: number[];
    showAllNewAndChangesSameCases?: boolean;
    showAllRejectedSameCases?: boolean;
    showOnlyRejectedSameCases?: boolean;

    pagedModel: IBasePagedModel;
    sortModel: IBaseSortModel<SameCaseSortColumns>;
}

export const useGetSameCasesQueryKey = 'get-case-groups-query';

export const useGetSameCasesQuery = (
    searchModel: ISameCaseMatchedCasesSearchModel,
    enabled: boolean
) => {
    return useQuery({
        queryKey: [useGetSameCasesQueryKey, { searchModel }],
        queryFn: async () => {
            const response = await _apiClient.searchSameCasesManage(searchModel);

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: HttpResponseError = new Error('Failed to search same cases');
                error.status = response.httpResponse.status;
                throw error;
            }

            return response.payload;
        },
        keepPreviousData: true,
        cacheTime: 0,
        staleTime: 0,
        enabled:
            enabled && searchModel.caseFileModelId !== undefined && searchModel.caseFileModelId > 0,
    });
};
